import { NavLink } from 'react-router-dom';
import { Home, FileText, Layout, Users, BarChart3, LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/lib/utils';

export const Sidebar = () => {
  const { user, logout } = useAuth();

  const navItems = [
    { to: '/dashboard', icon: BarChart3, label: 'Dashboard' },
    { to: '/cms/leads', icon: Users, label: 'Leads' },
    { to: '/cms/blog', icon: FileText, label: 'Blog' },
    { to: '/cms/pages', icon: Layout, label: 'Pages' },
  ];

  return (
    <aside className="w-64 bg-[#0a0a0a] border-r border-[#222] flex flex-col h-screen">
      {/* Logo / Brand */}
      <div className="p-6 border-b border-[#222]">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #E8651A, #F5922B)' }}>
            <span className="text-[#0a0a0a] font-bold text-sm">CG</span>
          </div>
          <div>
            <h2 className="text-base font-bold text-[#f5f5f5] tracking-tight">Custom Group</h2>
            <p className="text-[10px] text-[#666] uppercase tracking-widest">CMS</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center px-4 py-2.5 rounded text-sm transition-all',
                    isActive
                      ? 'bg-[#E8651A]/10 text-[#E8651A] font-medium border-l-2 border-[#E8651A]'
                      : 'text-[#888] hover:text-[#f5f5f5] hover:bg-[#111] border-l-2 border-transparent'
                  )
                }
              >
                <item.icon className="w-4 h-4 mr-3" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* User info + logout */}
      <div className="p-4 border-t border-[#222]">
        <div className="flex flex-col space-y-3">
          <div className="text-sm">
            <p className="font-medium text-[#f5f5f5] truncate">{user?.name || user?.email}</p>
            <p className="text-xs text-[#555] truncate">{user?.email}</p>
          </div>
          <button
            onClick={logout}
            className="flex items-center px-4 py-2 text-sm rounded text-[#888] hover:text-[#f5f5f5] hover:bg-[#111] transition-colors text-left w-full"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </button>
        </div>
      </div>
    </aside>
  );
};
